import { ChangeDetectorRef, Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebService } from "../../services/ebsWebService";
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";

@Component({
  selector: 'custom-body',
  templateUrl: 'custom-body.html',
  inputs: ['bodyData']
})
export class CustomBodyPage {

  bodyData: any;
  _ebsComponentService: EbsComponentService;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private cdRef: ChangeDetectorRef,
    private alertCtrl: AlertController,
    public _ebsWebService: EbsWebService,
    public _ebsWebServiceGlobals: EbsWebServiceGlobals) {

    this._ebsComponentService = new EbsComponentService(_ebsWebService, _ebsWebServiceGlobals);
  }

  ionViewDidLoad() {
    this.cdRef.detectChanges();
  }



  handleButtonAction(item) {
    if (item.AllowUpdate == true) {
      console.log("return");
      return;
    } else if (typeof item.Action != "undefined" && item.Action != "" && item.Action != null) {
      if (item.ViewTypeAction == 'Popup') {
        open(item.Action, 'popup', 'height=400,width=400,resizable=yes');
        return;
      } else if (item.ViewTypeAction == 'DownloadFile') {
        window.open(item.Action, '_blank');
        return;
      } else if (item.ViewTypeAction == 'IFrame') {
      }


      let navParams = {};
      if (item.ViewTypeAction == "Signature") {
        navParams = {
          signatureElement: item
        };
      } else {
        navParams = {
          title: item.ActionCaption,
          actionURL: item.Action,
          postParams: item.PostParameters
        };
      }
      this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
    } else {
      return;
    }
  }

  checkIfDataIsValid(data) {
    if (typeof data != "undefined" && data != "" && data != null) {
      return true;
    } else {
      return false;
    }
  }

  openPage(item) {


    if (this.checkIfDataIsValid(item.Dynamic) && typeof item.Dynamic.NeedsConfirmation != "undefined" && item.Dynamic.NeedsConfirmation != null && item.Dynamic.NeedsConfirmation != "" && item.Dynamic.NeedsConfirmation == "True") {
      let title = 'Dynamic:AlertTitle';
      if (this.checkIfDataIsValid(item.Dynamic.AlertTitle)) {
        title = item.Dynamic.AlertTitle;
      }

      let message = 'Dynamic:AlertMessage';
      if (this.checkIfDataIsValid(item.Dynamic.AlertMessage)) {
        message = item.Dynamic.AlertMessage;
      }

      let disableConfirmAction = false;
      if (this.checkIfDataIsValid(item.Dynamic.AlertDisableConfirmAction)) {
        if (item.Dynamic.AlertDisableConfirmAction == 'True') {
          disableConfirmAction = true;
        };
      }

      let alert = this.alertCtrl.create({
        title: title,
        message: message,
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
            handler: () => {
              console.log('Alert got canceled');
            }
          },
          {
            text: 'Bestätigen',
            handler: () => {
              console.log('Confirmed');
              if (!disableConfirmAction) {
                this.handleButtonAction(item);
              }

            }
          }
        ]
      });
      alert.present();
    } else {
      this.handleButtonAction(item);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/custom-body/custom-body.ts